/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Services_Event_TitleInputs */

const ja_playdata_home_services_event_title = /** @type {(inputs: Playdata_Home_Services_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eスポーツイベントレポート`)
};

const en_playdata_home_services_event_title = /** @type {(inputs: Playdata_Home_Services_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esports Event Report`)
};

/**
* | output |
* | --- |
* | "Esports Event Report" |
*
* @param {Playdata_Home_Services_Event_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_services_event_title = /** @type {((inputs?: Playdata_Home_Services_Event_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Services_Event_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_services_event_title(inputs)
	return en_playdata_home_services_event_title(inputs)
});